import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { reducer, portalRolesFeatureKey } from './portal-roles.reducer';
import { PortalRolesService } from './services/portal-roles.service';
import { PortalRolesEffects } from './portal-roles.effects';
import { EffectsModule } from '@ngrx/effects';

@NgModule({
  imports: [
    StoreModule.forFeature(portalRolesFeatureKey, reducer),
    EffectsModule.forFeature([PortalRolesEffects]),
  ],
  providers: [PortalRolesService, PortalRolesEffects],
})
export class PortalRolesModule {}
